import Vue from 'vue';

Vue.component('hidden-container', () => import('./modules/hidden-container'));
